<template>
  <div class="copyright-block">
    <p>©{{ year }} Asoko Insight. All right reserved.</p>
    <p>We will respect your privacy.</p>
    <p><a href="/about/legal">See our terms.</a></p>
  </div>
</template>

<script>
export default {
  name: 'copyright',
  data() {
    return {
      year: new Date().getFullYear(),
    }
  },
}
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0px;
}
a {
  color: $link-dark-color;
}
</style>
